import * as React from 'react';
import { useContext } from 'react';
import { IContactsAction, IContactsContextState } from './contacts-interfaces';
import { ContactsInitialVariables } from './contacts-variables';
import { contactsReducer } from './contacts-reducer';

type ContactsProviderProps = { children: React.ReactNode }

const ContactsStateContext = React.createContext<{ contactsContextState: IContactsContextState; dispatch: React.Dispatch<IContactsAction> } | undefined>(undefined);

const ContactsProvider = ({ children }: ContactsProviderProps): JSX.Element => {
	const [contactsContextState, dispatch] = React.useReducer(contactsReducer, ContactsInitialVariables);
	const value = { contactsContextState, dispatch };
	return (
		<ContactsStateContext.Provider value={value}>
			{children}
		</ContactsStateContext.Provider>
	);
};

const useContactsContext = (): { contactsContextState: IContactsContextState; dispatch: React.Dispatch<IContactsAction> } => {
	const context = useContext(ContactsStateContext);
	if (context === undefined) {
		throw new Error('useContactsContext must be used within a OrderProvider');
	}
	return context;
};

export { ContactsProvider, useContactsContext };
